export default {
  HOME_ROUTE: {
    PARENT: "",
    ROUTE: "/",
  },
  LOGIN_ROUTE: {
    PARENT: "auth/",
    ROUTE: "login",
  },
  REGISTER_ROUTE: {
    PARENT: "auth/",
    ROUTE: "register",
  },
  PASSWORD_RESET_ROUTE: {
    PARENT: null,
    ROUTE: "password/reset",
  },
  PASSWORD_UPDATE_ROUTE: {
    PARENT: null,
    ROUTE: "password/update/:uuid",
  },
  REGISTER_COMPLETE_ROUTE: {
    PARENT: "auth/",
    ROUTE: "register/complete",
  },
  AUCTION_ROUTE: {
    PARENT: "auction",
    ROUTE: "/",
  },
  AUCTION_CREATE_ROUTE: {
    PARENT: "auction/",
    ROUTE: "create",
  },
  AUCTION_INNER_PAGE_ROUTE: {
    PARENT: "auction/",
    ROUTE: ":id",
  },
  ADMIN_ROUTE: {
    PARENT: "admin",
    ROUTE: "/",
  },
  PROFILE_ROUTE: {
    PARENT: "profile",
    ROUTE: "/",
  },
  PROFILE_PERSONAL_INFORMATION: {
    PARENT: "profile/",
    ROUTE: "personal-information",
  },
  PROFILE_CHANGE_PASSWORD: {
    PARENT: "profile/",
    ROUTE: "change-password",
  },
  PROFILE_BANK_DETAILS: {
    PARENT: "profile/",
    ROUTE: "bank-details",
  },
  PROFILE_MY_AUCTIONS: {
    PARENT: "profile/",
    ROUTE: "my-auctions",
  },
  PROFILE_FAVORITES: {
    PARENT: "profile/",
    ROUTE: "favorites",
  },
  PROFILE_NOTIFICATIONS: {
    PARENT: "profile/",
    ROUTE: "notifications",
  },
  PROFILE_TRANSACTION_HISTORY: {
    PARENT: "profile/",
    ROUTE: "transaction-history",
  },
  TERMS_AND_CONDITIONS_ROUTE: {
    PARENT: "/",
    ROUTE: "terms-and-conditions",
  },
  PAYMENT_ROUTE: {
    PARENT: "payment/:result",
    ROUTE: "/",
  },
  WARNING: {
    PARENT: "/",
    ROUTE: "warning",
  },
};
